import { render, staticRenderFns } from "./UITable.vue?vue&type=template&id=3dc8bc6a"
import script from "./UITable.vue?vue&type=script&lang=js"
export * from "./UITable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports